import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

/**
 * Generative brand-color mesh — the fallback for Discover cover slots with
 * no resolvable real photo (a data gap on someone else's content, not
 * *your* empty album — see `AlbumCard`'s "No photos yet" for that owner-
 * facing case, which stays as-is since "go add a photo" is actionable
 * there and isn't here). A flat gray box or "No photos yet" text both read
 * as broken on a browse surface; this is a light-mode take on the brand's
 * gold/coral/violet/cyan accent-dot palette instead — same spirit as the
 * "Generative Wall Field" concept in
 * docs/mockups-v22/01-hero-cover-redesign.html (Option C), just softened
 * for a small card thumbnail rather than a full hero.
 */
export const CoverMesh = styled(Box)({
  width: '100%',
  height: '100%',
  background: `
    radial-gradient(ellipse 60% 70% at 14% 20%, rgba(255,207,125,0.5), transparent 60%),
    radial-gradient(ellipse 55% 65% at 88% 10%, rgba(254,166,125,0.4), transparent 62%),
    radial-gradient(ellipse 60% 75% at 82% 95%, rgba(190,157,253,0.45), transparent 62%),
    radial-gradient(ellipse 45% 55% at 6% 90%, rgba(1,218,254,0.35), transparent 60%),
    var(--ds-surface)
  `,
})
